import React, {useEffect} from 'react'
import { Row } from 'react-bootstrap'
import { auth } from '../../../networking/firebase'
import { ToastContainer } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import AccountShowcase from './account-showcase'
import DashboardAccountRightContainer from './account-navigation'
import { resetDeleteUserImage, resetUpdateUserGeneral, resetUpdateUserImage, resetUpdateUserInfo, resetUpdateUserPassword, retrieveFullName, retrieveUserImage } from '../../../redux/actions/user'
import { sendErrorNotification, sendSuccessNotification } from '../../universal/notifications/notifications'
import './style.scss'

const Index = () => {

	const dispatch = useDispatch()

	const updateInfoError = useSelector(state => state.user.updateInfo.error)
	const updateInfoStatus = useSelector(state => state.user.updateInfo.status)

	const updateGeneralError = useSelector(state => state.user.updateGeneral.error)
	const updateGeneralStatus = useSelector(state => state.user.updateGeneral.status)

	const updatePasswordError = useSelector(state => state.user.updatePassword.error)
	const updatePasswordStatus = useSelector(state => state.user.updatePassword.status)

	const uploadImageError = useSelector(state => state.user.updateImage.error)
	const uploadImageStatus = useSelector(state => state.user.updateImage.status)

	const deleteImageError = useSelector(state => state.user.deleteImage.error)
	const deleteImageStatus = useSelector(state => state.user.deleteImage.status)

	useEffect(() => {
		dispatch(resetUpdateUserInfo())
		dispatch(resetUpdateUserGeneral())
		dispatch(resetUpdateUserPassword())
		dispatch(resetUpdateUserImage())
		dispatch(resetDeleteUserImage())
	}, [])
	
	useEffect(() => {

		if(updateInfoStatus){
			sendSuccessNotification("Endringene ble lagret.")
			dispatch(resetUpdateUserInfo())
			dispatch(retrieveFullName(auth.currentUser.uid))
		  }
	
		  if(updateInfoError){
			sendErrorNotification("Kunne ikke lagre endringer.")
			dispatch(resetUpdateUserInfo())
			dispatch(retrieveFullName(auth.currentUser.uid))
		  }
		  // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [updateInfoStatus, updateInfoError])

	useEffect(() => {

		if(updateGeneralStatus){
			sendSuccessNotification("Endringene ble lagret.")
			dispatch(resetUpdateUserGeneral())
		  }
	
		  if(updateGeneralError){
			sendErrorNotification("Kunne ikke lagre endringer.")
			dispatch(resetUpdateUserGeneral())
		  }
		  // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [updateGeneralStatus, updateGeneralError])

	useEffect(() => {

		if(updatePasswordStatus){
			sendSuccessNotification("Passordet ble oppdatert.")
			dispatch(resetUpdateUserPassword())
		  }
	
		  if(updatePasswordError){
			sendErrorNotification("Kunne ikke endre passord.")
			dispatch(resetUpdateUserPassword())
		  }
		  // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [updatePasswordStatus, updatePasswordError])

	useEffect(() => {

		if(uploadImageStatus){
			sendSuccessNotification("Bildet ditt ble oppdatert.")
			dispatch(retrieveUserImage(auth.currentUser.uid))
			dispatch(resetUpdateUserImage())
		  }

		  if(uploadImageError){
			sendErrorNotification("Kunne ikke oppdatere bilde.")
			dispatch(resetUpdateUserImage())
		  }
		  // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uploadImageStatus, uploadImageError])

	useEffect(() => {

		if(deleteImageStatus){
			sendSuccessNotification("Bildet ble slettet.")
			dispatch(retrieveUserImage(auth.currentUser.uid))
			dispatch(resetDeleteUserImage())
		  }

		  if(deleteImageError){
			sendErrorNotification("Kunne ikke slette bilde.")
			dispatch(resetDeleteUserImage())
		  }
		// eslint-disable-next-line react-hooks/exhaustive-deps

	}, [deleteImageStatus, deleteImageError])


    return(
    	<section className="dashboard-account-section">
      	<div className="inner-dashboard-account-container">
			<Row className="dashboard-account-row">
				<AccountShowcase/>
				<DashboardAccountRightContainer/>
			</Row>
        </div>
		<ToastContainer/>
      </section>
    )
}

export default Index
